<template>
  <AppDialog
    v-if="hasActiveIntegration"
    v-model="dialogImport"
    width="1000px"
    style="position: relative"
  >
    <template v-slot:activator="{ on, attrs }">
      <slot v-bind="{on,attrs}">
        <VBtn
          v-bind="attrs"
          v-on="on"
          color="success"
        >
          {{ $t('import') }}
        </VBtn>
      </slot>
    </template>
    <IntegrationsVacancyList
      v-if="dialogImport"
      @saved="dialogImport = false"
      @cancel="dialogImport = false"
    />
  </AppDialog>
</template>
<script>
import IntegrationsVacancyList from '@/components/Integrations/IntegrationsVacancyList';
import { ref } from '@vue/composition-api';
import useIntegrations from '@/compositions/useIntegrations';
import AppDialog from '@/components/AppDialog';

export default {
  name: 'IntegrationsVacancyImportDialog',
  components: {
    AppDialog,
    IntegrationsVacancyList,
  },
  setup() {
    const dialogImport = ref(false);
    const { hasActiveIntegration, fetchAll } = useIntegrations();
    fetchAll();
    return {
      dialogImport,
      hasActiveIntegration,
    };
  },
};
</script>

<style lang="scss" scoped>

</style>

<i18n lang="yml" locale="en">
import: Import
</i18n>
<i18n lang="yml" locale="ru">
import: Импортировать вакансии
</i18n>
